export default function generateDatasets(vars, variables) {
  return vars.map(({name, idvar, data}) => ({
    label: name,
    data: data.map(
      ({time, value}) => ({
        x: time,
        y: parseFloat(value)
      })
    ),
    type: "line",
    pointRadius: 0,
    tension: 0,
    borderWidth: 2,
    fill: false,
    borderColor: variables[idvar].color,
    backgroundColor: variables[idvar].color,
  }));
}
